import React, { ReactNode } from 'react'
import { Box } from '@chakra-ui/react'
import { Navigate } from 'react-router-dom'

import Sidebar from './Sidebar'
import useAuth from '../hooks/useAuth'

interface LayoutProps {
  children: ReactNode
  title?: string
}

const Layout: React.FC<LayoutProps> = ({ children, title }) => {
  const { isAuthenticated, address, logout } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return (
    <Box minH="100vh" bg="gray.50">
      <Sidebar walletAddress={address} onLogout={logout} />
      <Box ml={{ base: '60' }} position="relative">
        {/* Content */}
        <Box p="5">{children}</Box>
      </Box>
    </Box>
  )
}

export default Layout
